import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import SaveModal from '../modal/saveModal';
import '../../common/css/serviceDetail.css';

function StandbyDetail() {
    const [modalAction, setModalAction] = useState(null);
    const [modalContent, setModalContent] = useState(null);
    const [saveStatus, setSaveStatus] = useState(true);
    const [detailData, setDetailData] = useState(true);

    // 서버통신
    useEffect(() => {
        const axiosData = async () => {
            try {
                const params = new URLSearchParams(window.location.search);
                const seq = params.get('seq') ?? 1;
                const hostname = window.location.hostname;
                let isLocal = null;
                if (hostname === 'wpal.philippineair.co.kr') {
                    isLocal = true;
                } else {
                    isLocal = false;
                }

                const response = await axios.get(
                    `${
                        isLocal
                            ? process.env.REACT_APP_PRODUCTION_API_URL
                            : process.env.REACT_APP_LOCAL_API_URL
                    }/wpal/board/standby/detail?seq=${seq}`,
                    {
                        withCredentials: true,
                    },
                );
                setDetailData(response.data);
            } catch (error) {
                console.error(error);
            }
        };

        if (Cookies.get('isLogin')) {
            axiosData();
        } else {
            setModalContent('로그인 후 이용 가능한 서비스 입니다.');
            setModalAction(() => () => (window.location.href = '/login'));
            setSaveStatus(false);
        }
    }, []);

    const requestDelete = async () => {
        try {
            const hostname = window.location.hostname;
            let isLocal = null;
            if (hostname === 'wpal.philippineair.co.kr') {
                isLocal = true;
            } else {
                isLocal = false;
            }

            const seq = window.location.search.split('=')[1];
            const response = await axios.post(
                `${
                    isLocal
                        ? process.env.REACT_APP_PRODUCTION_API_URL
                        : process.env.REACT_APP_LOCAL_API_URL
                }/wpal/board/standby/delete/${seq}`,
                {},
                {
                    withCredentials: true,
                },
            );

            if (response.data.rowsAffected[0] === 1) {
                setModalContent('삭제 완료되었습니다.');
                setModalAction(() => () => (window.location.href = '/service/standbyList'));
                setSaveStatus(false);
            }
        } catch (error) {
            setModalContent('삭제 요청중 오류가 발생했습니다.');
            setModalAction(() => () => setSaveStatus(true));
            setSaveStatus(false);
        }
    };

    return (
        <div className='bodyContainer '>
            <div class='subp_h_wrap'>
                <div class='subp_h_list subp_h_home'>
                    <div>서비스요청</div>
                    <div>대기 전문 요청</div>
                    <div>요청 내역 확인</div>
                </div>
            </div>
            <div className='sis-contents' id='contents'>
                <div className='mypageFromWrap'>
                    <div class='page_hgroup'>
                        <h2 class='title'>대기 전문 요청 상세</h2>
                    </div>
                    <div className='agentCheckWrap'>
                        <h4>요청 내용</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>담당자</th>
                                    <td>
                                        <div className='table-padding sis-divWeight' id='name'>
                                            {detailData.regAgtName}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>휴대폰번호</th>
                                    <td>
                                        <div className='table-padding sis-divWeight' id='userPhone'>
                                            {detailData.regAgtPhone}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>항공사 예약번호</th>
                                    <td>
                                        <div
                                            className='table-padding sis-divWeight'
                                            id='agentTranNum'
                                        >
                                            {detailData.air_pnr}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>비고</th>
                                    <td>
                                        <div className='table-padding sis-divWeight' id='remark'>
                                            {detailData.etc}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className='agentInfo'>
                        <h4>처리 결과</h4>

                        <table className='mypage-table'>
                            <tbody>
                                <tr className='firstTable-border'>
                                    <th>상태</th>
                                    <td>
                                        <div className='table-padding sis-divWeight' id='status'>
                                            {detailData.status}
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <th>항공사 비고</th>
                                    <td>
                                        <div className='table-padding sis-divWeight'>
                                            {detailData.air_etc}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    {detailData.status === '요청중' ? (
                        <div className='submitArea' style={{ display: 'flex', gap: '75px' }}>
                            <input
                                class={`each-button`}
                                type='button'
                                value='삭제하기'
                                onClick={() => requestDelete()}
                            />
                        </div>
                    ) : (
                        <></>
                    )}
                </div>
            </div>
            <SaveModal content={modalContent} SaveBtn={saveStatus} onClose={modalAction} />
        </div>
    );
}

export default StandbyDetail;
